import React from 'react';
import { User, MapPin, Phone, MessageSquare } from 'lucide-react';

const CardHeader = ({ profile, theme, themeVars }) => {
  const p = profile.profile || {};
  const t = theme;
  const { subtleBg, subtleBorder, mutedText } = themeVars;

  const hasQuickActions = p.whatsapp || p.telegram || p.signal || p.phone;

  return (
    <>
      {/* Cover Image */}
      {p.cover_image_url && (
        <div className="rounded-t-2xl overflow-hidden mb-[-40px] relative z-0" data-testid="public-cover-image">
          <img src={p.cover_image_url} alt="Cover" className="w-full h-32 object-cover" />
        </div>
      )}
      
      {/* Profile header */}
      <div className="flex flex-col items-center mb-8">
        <div className="relative mb-5" style={{ zIndex: 1 }}>
          <div className="w-28 h-28 rounded-full overflow-hidden ring-4 card-profile-photo" style={{ borderColor: subtleBorder, backgroundColor: t.bg_color, ringColor: t.bg_color }}>
            {p.image_url ? (
              <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" data-testid="public-profile-image" />
            ) : (
              <div className="w-full h-full flex items-center justify-center" style={{ background: subtleBg }}>
                <User className="w-10 h-10" style={{ color: mutedText }} />
              </div>
            )}
          </div>
        </div>
        <h1 className="font-heading text-2xl font-medium tracking-tight" style={{ color: t.name_color || t.text_color }} data-testid="public-profile-name">{p.name}</h1>
        {p.title && <p className="text-sm font-semibold mt-1" style={{ color: t.accent_color || t.primary_color }} data-testid="public-profile-title">{p.title}</p>}
        {p.company && <p className="text-sm font-medium" style={{ color: mutedText }}>{p.company}</p>}
        {p.location && (
          <div className="flex items-center gap-1.5 mt-2" style={{ color: mutedText }}>
            <MapPin className="w-3 h-3" />
            <span className="text-xs">{p.location}</span>
          </div>
        )}
        {p.bio && <p className="text-xs mt-3 text-center max-w-xs leading-relaxed px-4" style={{ color: mutedText }}>{p.bio}</p>}
        
        {/* Quick Action Buttons */}
        {hasQuickActions && (
          <div className="flex flex-wrap justify-center gap-2 mt-4" data-testid="quick-actions">
            {p.phone && (
              <a href={`tel:${p.phone}`} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-transform hover:scale-105"
                style={{ background: subtleBg, border: `1px solid ${subtleBorder}` }} data-testid="quick-call">
                <Phone className="w-3.5 h-3.5" style={{ color: t.primary_color }} /> Call
              </a>
            )}
            {p.whatsapp && (
              <a href={`https://wa.me/${p.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-transform hover:scale-105"
                style={{ background: '#25D366', color: '#fff' }} data-testid="quick-whatsapp">
                <MessageSquare className="w-3.5 h-3.5" /> WhatsApp
              </a>
            )}
            {p.telegram && (
              <a href={`https://t.me/${p.telegram.replace('@', '')}`} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-transform hover:scale-105"
                style={{ background: '#0088cc', color: '#fff' }} data-testid="quick-telegram">
                <MessageSquare className="w-3.5 h-3.5" /> Telegram
              </a>
            )}
            {p.signal && (
              <a href={`https://signal.me/#p/${p.signal.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-transform hover:scale-105"
                style={{ background: '#3A76F0', color: '#fff' }} data-testid="quick-signal">
                <MessageSquare className="w-3.5 h-3.5" /> Signal
              </a>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CardHeader;
